let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kqgin")).then(() => parcelRequire('jgSdJ'));